import axios from "axios";
import { useQuery } from "react-query";

// Platform-wide figures: ranked players, countries represented, tournaments,
// and the top countries by ranked player count.
const getStats = async () => {
  const response = await axios.get("/api/v1/public/stats");
  return response.data; // { success, data: {...} }
};

export const useStats = () => {
  return useQuery("stats", getStats, {
    // These move once a week at most — no need to refetch on every mount.
    staleTime: 5 * 60 * 1000,
  });
};
